// THIS MODULE FOR UI ONLY / SAMPLE SHOW 
// Can use one template only -  VisitorTable.jsx for code
 
import React from "react";
import { Table } from 'react-bootstrap';
import { UserPlus, 
        ArrowNarrowRight 
    } from 'tabler-icons-react';

const VisitorTable2 = () => {
    return (
        <div className="visitorTableSec">

            {/* SEPERATOR LINE */}
            <div className="vertLine flip-in-hor-top2"></div>


            {/* TABLE SECTION */}
            <h2 className="fade-in-tl7"><b>VISITOR DETAILS</b></h2>
            <br />
            <div className="tableSec">
                <Table className="customTable fade-in-br8" striped bordered hover>
                    <thead>
                        <tr>
                            <th>SN</th>
                            <th>FULL NAME</th>
                            <th>MOBILE</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>Tan A Meng</td>
                            <td>+6587200351</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>Tan A Tock</td>
                            <td>+6587200352</td>
                        </tr>
                        {/* <tr>
                            <td>3</td>
                            <td>Tan A Seng</td>
                            <td>+6587200353</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>Tan A Lock</td>
                            <td>+6587200354</td>
                        </tr> */}
                    </tbody>
                </Table>

                <br />
                <hr className="fade-in-left6"/>

                <div className="addInfo fade-in-left7">
                   <span className="fcolorRed">NOTE:</span>
                    <p> To add more visitor click here
                    <ArrowNarrowRight size={50} strokeWidth={2} color={'blue'} />
                    </p>
                </div>
                <div className="addPortion fade-in-br10"> 
                    <button type="button" className="btnRdCorn">
                        <UserPlus size={35} strokeWidth={2} color={'white'} /><br />
                        <p>ADD VISITOR</p>
                    </button>
                </div>


            </div>

        </div>
    );
}

export default VisitorTable2;